import { Routes } from '@angular/router';
import { LoginComponent } from 'src/app/pages/auth/login/login.component';
import { AuthGuard, IsLoggedInGuard } from './shared/guards/auth.guard';
import { PrintAnswerComponent } from 'src/app/pages/answers/print-answer/print-answer.component';
import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';
import { HOME_LAYOUT_ROUTES } from './layouts/home-layout/home-layout.routes';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: HOME_LAYOUT_ROUTES
  },
  {
    path: 'print-answer/:id',
    canActivate: [AuthGuard],
    component: PrintAnswerComponent,
  },
  // {
  //   path: '',
  //   canActivate: [IsLoggedInGuard],
  //   component: LoginComponent,
  // },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [IsLoggedInGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
